import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { ButtonDirective, IconDirective } from 'shared/ui-common';

import { ColorPreset } from '@treetop/shared/color-presets';

@Component({
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'tt-color-preset-card',
  templateUrl: './color-preset-card.component.html',
  styleUrls: ['./color-preset-card.component.scss'],
  imports: [ButtonDirective, MatIcon, IconDirective],
  host: {
    '[style.--color-preset-card-bg]': 'colorPreset()?.fill',
    '[style.--color-preset-card-stroke]': 'colorPreset()?.stroke',
    '[style.--color-preset-card-text]': 'colorPreset()?.text',
  },
})
export class ColorPresetCardComponent {
  public colorPreset = input.required<ColorPreset>();
  public readonly = input(false);

  public editClicked = output();
  public deleteClicked = output();
}
